<template>
  <div class="columns is-block ranking-section">
    <!-- Header Begins -->
    <div class="column has-text-centered is-full header-section">
      <div class="columns is-block divider">
        <div class="column has-text-left is-full" v-if="internalAttributes.showings.showHeader">
          <b class="bold-text">{{internalAttributes.header.title}}</b> <span class="lighter-text"> {{internalAttributes.header.subtitle}} </span>
        </div>
        <div class="column is-full padding-top-bottom-12" v-if="internalAttributes.showings.showSubheader">
          <div class="columns is-flex-mobile growth">
            <div class="column has-text-left">
              <img :src="`/static/img/grow-${internalAttributes.growth ? 'up' : 'down'}.svg`" alt="growth" v-if="internalAttributes.showGrowth"> <span v-if="internalAttributes.showGrowth" v-html="internalAttributes.texts.leftText"></span>
            </div>
            <div class="column has-text-right">
              <p><span v-html="internalAttributes.texts.rightText"></span></p>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- Header Ends -->
    <!-- Stats Begins -->
    <div class="column padding-top-bottom-12">
      <div class="columns is-flex-mobile" v-for="position in internalAttributes.positions">
        <div class="column is-narrow is-1-mobile">
          <span>{{position.month}}</span>
        </div>
        <div class="column dotted-border">
          <span></span>
        </div>
        <div class="column is-narrow is-1-mobile has-text-right">
          <span>{{position.stat}}</span>
        </div>
      </div>
    </div> <!-- Stats Ends -->
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc,one-var */
  export default {
    name: 'RankingWidget',
    props: {
      attributes: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      /**
       * Compute internal attributes
       * @return {Object}
       */
      internalAttributes () {
        return Object.assign({
          growth: 1,
          showGrowth: true,
          showings: {
            showHeader: true,
            showSubheader: true
          },
          header: {
            title: 'Industry ranking',
            subtitle: '(last 12 months)'
          },
          texts: {
            leftText: `<span style="font-size: 18px; font-weight: bold;">5 </span> places`,
            rightText: `<span style="font-size: 18px; font-weight: bold;">#3</span> in banking`
          },
          positions: [
            {
              month: 'July',
              stat: '#2'
            },
            {
              month: 'June',
              stat: '#1'
            },
            {
              month: 'May',
              stat: '#1'
            }
          ]
        }, this.attributes)
      }
    }
  }
</script>

<style lang="scss" scoped>
  $text-color: #58595b;
  $progress-color: #6a4ee4;

  .ranking-section {
    color: $text-color;
    border: solid 1px rgba(88, 89, 91, 0.32);
    padding: 10px 15px;
    font-size: 12px;

    .column {
      margin: auto 0;
      padding: 0;
    }
    .header-section {
      margin-bottom: 8px;

      .divider {
        border-bottom: 1px solid #dbdbdb;
        margin-bottom: 0 !important;
        padding: 0 0 12px 0 !important;
      }
      .bold-text {
        font-size: 12px;
        font-weight: bold;
      }
    }
    .growth {
      img {
        width: 9.6px;
        height: 19.1px;
        object-fit: contain;
      }
    }
  }
  .lighter-text {
    font-size: 11px;
  }
  .bolder-text {
    font-size: 18px;
    font-weight: bold;
  }
  .dotted-border {
    margin: 0 9px 7px !important;
    border-bottom: 1px dotted rgba(88, 89, 91, 0.32);
  }

  /* Helper css begins */
  .padding {
    &-top {
      &-bottom {
        &-12 {
          padding: 12px 0 !important;
        }
      }
    }
  }
  /* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/widgets/home/RankingWidget.vue